import script from "./Alumnus.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alumnus.vue?vue&type=script&lang=ts&setup=true"

import "./Alumnus.vue?vue&type=style&index=0&id=5b9a0701&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b9a0701"]])

export default __exports__